import http from 'apis/config/http-service';
import { useInfiniteQuery } from 'react-query';
import type { LookupRestaurant } from './types';

const endpoint = 'api/v1/restaurants';
const PAGE_SIZE = 20;

interface LookupRestaurantsPage {
  data: LookupRestaurant[];
  page: number;
  pageCount: number;
  total: number;
}

// The picker shows ALL restaurants immediately (newest first), infinite-
// scrolled; `search` narrows server-side. No minimum-characters gate.
//
// qsupply/backend's CMS restaurant list (`{ data, page, pageCount, total }`, rows carry `nameEn`).
export const useInfiniteLookupRestaurantsApi = (search: string) => {
  const trimmed = search.trim();

  return useInfiniteQuery(
    [endpoint, 'lookup-infinite', trimmed],
    async ({ pageParam = 1 }): Promise<LookupRestaurantsPage> => {
      const { data } = await http.get(endpoint, {
        params: { page: pageParam, limit: PAGE_SIZE, sort: 'id.desc', name: trimmed || undefined },
      });
      return data;
    },
    {
      getNextPageParam: (last) => (last.page < last.pageCount ? last.page + 1 : undefined),
      keepPreviousData: true,
      staleTime: 1000 * 60,
    }
  );
};
